import {z} from 'zod';

export const feedbackCategory = z.enum([
  'layout',
  'colors',
  'typography',
  'content',
  'spacing',
  'images',
]);

export type FeedbackCategory = z.infer<typeof feedbackCategory>;

export const feedbackAttachment = z.object({
  type: z.literal('dislikeFeedback'),
  categories: z.array(feedbackCategory),
  freeText: z.string(),
  originalStructureId: z.string(),
  originalPrompt: z.string(),
  screenshotUrl: z.url(),
});
